import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/commerce/RecommendationsMetrics.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/reports/v1/recommendations/slots`;
	}
	list(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}`, e));
	}
	get(e, t) {
		return this.api.get(this.buildPath(`${n.baseUrl}/${e}`, t));
	}
	getProductsMetrics(e, t) {
		return this.api.get(this.buildPath(`${n.baseUrl}/${e}/products`, t));
	}
};
export { n as RecommendationsMetrics };

//# sourceMappingURL=RecommendationsMetrics.js.map